import * as React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Root = styled.section((props) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: props.$fullWidth ? 0 : 40,
}));

const InnerContainer = styled.div((props) => {
  const { $maxWidth } = props;
  return {
    width: "100%",
    maxWidth: $maxWidth,
  };
});

function Section(props) {
  const { className, children, style, maxWidth = 1450, id } = props;

  return (
    <Root
      data-component-name="section"
      className={className}
      style={{ backgroundColor: style?.backgroundColor }}
      $fullWidth={maxWidth === null}
      id={id}
    >
      <InnerContainer
        data-component-name="section-content"
        $maxWidth={maxWidth}
      >
        {children}
      </InnerContainer>
    </Root>
  );
}

Section.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  maxWidth: PropTypes.number,
  style: PropTypes.shape({
    backgroundColor: PropTypes.string,
  }),
};

export default Section;
